/**
 * @file 全局配置（逐渐废除config_v2.js）
 */

// 支持的语言列表，新增语言时需要这里定义并且配置接口中也需要返回
export const supportLanguages = [
  {
    iso: 'en-US',
    name: 'English',
    zendesk: 'en-us',
    zc: 'en',
    hreflang: 'en'
  },
  {
    iso: 'tr-TR',
    name: 'Türkçe',
    zendesk: 'tr',
    zc: 'tr'
  },
  {
    iso: 'ko-KR',
    name: '한국어',
    zendesk: 'ko-kr',
    zc: 'ko'
  },
  {
    iso: 'ru-RU',
    name: 'русский',
    zendesk: 'ru',
    zc: 'ru',
    hreflang: 'ru'
  },
  {
    iso: 'zh-TW',
    name: '繁體中文',
    zendesk: 'zh-tw',
    zc: 'tw',
    hreflang: 'zh-Hant'
  },
  {
    iso: 'ja-JP',
    name: '日本語',
    zendesk: 'ja-jp',
    zc: 'ja',
    hreflang: 'ja'
  },
  {
    iso: 'pt-PT',
    name: 'Portuguese',
    zendesk: 'pt',
    zc: 'pt',
    hreflang: 'pt'
  },
  {
    iso: 'es-ES',
    name: 'España',
    zendesk: 'es',
    zc: 'es',
    hreflang: 'es'
  },
  {
    iso: 'vi-VN',
    name: 'Tiếng Việt',
    zendesk: 'vi',
    zc: 'vi',
    hreflang: 'vi'
  },
  {
    iso: 'fa-IR',
    name: 'فارسی',
    zendesk: 'fa',
    direction: 'rtl',
    route: 'fa',
    zc: 'fa',
    hreflang: 'fa'
  },
  {
    iso: 'ar-SA',
    name: 'العربية',
    zendesk: 'ar',
    zc: 'ar',
    direction: 'rtl'
  },
  {
    iso: 'nl-NL',
    name: 'Nederlands',
    zendesk: 'nl',
    zc: 'nl',
    hreflang: 'nl'
  },
  {
    iso: 'pl-PL',
    name: 'Polski',
    zendesk: 'pl',
    zc: 'pl',
    hreflang: 'pl'
  },
  {
    iso: 'id-ID',
    name: 'Indonesia',
    zendesk: 'id',
    zc: 'id',
    hreflang: 'id'
  }
];

export const supportLanguagesMap: Record<string, any> = {};
supportLanguages.forEach(item => {
  supportLanguagesMap[item.iso] = item;
});

export default {
  supportLanguages,
  supportLanguagesMap
};

